// import { asyncRoutes, constantRoutes } from '@/router'

import { getMockMenus } from "@/api/user"
import { GetUserMenu, GetAllMenu } from "@/api/Sys/sysugp_menu"
// import { routesFromMock } from '@/settings'
import { getTopMenu, setTopMenu } from "@/utils/auth"
import defaultSettings from "@/settings"
const { routesFromMock } = defaultSettings

const state = {
  routes: [],
  choise_top_menu_path: getTopMenu(),
  // addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.routes = routes // constantRoutes
  },
  SET_TOP_MENU_PATH: (state, path) => {
    state.choise_top_menu_path = path
  },
}

const actions = {
  generateRoutes({ commit }) {
    return new Promise((resolve) => {
      routesFromMock
        ? getMockMenus().then((jsonRoutes) => {
            // const cloneRouters = deepClone(jsonRoutes)
            // console.log(cloneRouters)
            // ResetMenu({ menus: cloneRouters })
            const accessedRoutes = filterAsyncRoutes(jsonRoutes)
            // console.log(accessedRoutes)
            commit("SET_ROUTES", accessedRoutes)
            resolve(accessedRoutes)
          })
        : GetUserMenu().then((jsonRoutes) => {
            const accessedRoutes = filterAsyncRoutes(jsonRoutes)
            // console.log(accessedRoutes)
            commit("SET_ROUTES", accessedRoutes)
            resolve(accessedRoutes)
          })
    })
  },
  routeClear({ commit }) {
    commit("SET_ROUTES", null)
  },
  choiseTop({ commit }, path) {
    commit("SET_TOP_MENU_PATH", path)
    setTopMenu(path)
  },
}

function filterAsyncRoutes(routers) {
  // 遍历后台传来的路由字符串，转换为组件对象
  const accessedRouters = routers.filter((router) => {
    // console.log(router)
    if (router.meta) {
      // 默认图标处理
      router.meta.icon = router.meta.icon ? router.meta.icon : "component"
      if (router.meta.title) router.meta.title = $trans(router.meta.title)
    }
    if (router.component === "Layout") {
      // Main组件特殊处理
      router.component = Layout
    } else if (router.component) {
      // 处理组件---重点
      router.component = loadView(router.component)
    } else {
      router.component = Empty
    }

    // 存在子集
    if (router.children && router.children.length) {
      router.children = filterAsyncRoutes(router.children)
    }
    return true
  })
  return accessedRouters
}

export const loadView = (view) => {
  // 路由懒加载
  // return () => import('@/views/' + view)
  // 打包方式的不同 使用了require 方式加载
  // let componentPath =
  // console.log(`@/views/${view}`)
  return (resolve) => require([`@/views/${view}`], resolve)
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
